import CryptoJS from "crypto-js";
import C from "@/utils/constants";

const crypto = {
  encrypt(data) {
    const cipher = CryptoJS.AES.encrypt(
      data,
      CryptoJS.enc.Utf8.parse(C.ObfuscationSeed),
      {
        iv: CryptoJS.enc.Utf8.parse(C.ObfuscationSeed),
        mode: CryptoJS.mode.CBC,
      },
    );

    console.log("encrpyting...");
    console.log(cipher.toString());
    return cipher.toString();
  },
  decrypt(data) {
    const cipher = CryptoJS.AES.decrypt(
      data,
      CryptoJS.enc.Utf8.parse(C.ObfuscationSeed),
      {
        iv: CryptoJS.enc.Utf8.parse(C.ObfuscationSeed),
        mode: CryptoJS.mode.CBC,
      },
    );

    return CryptoJS.enc.Utf8.stringify(cipher).toString();
  },
};

export default crypto;
